import { useComboSelectionContext } from '../../state/combo-selection';
import { useMenuPicker } from '../../state/menu-picker';

export const useProductDisplayName = ({ displayName = '', isStaticDetails = false }) => {
  const { isComboEnabled } = useComboSelectionContext();
  const menuPicker = useMenuPicker();

  const combo = menuPicker.query.data?.combo;
  const formattedDisplayName =
    !isStaticDetails && isComboEnabled && combo && !combo.isRequired
      ? `${displayName} Combo`
      : displayName;

  return formattedDisplayName;
};
